import React, { useContext, useState } from 'react';
import Button from 'components/Atoms/Button';
import loadable from '@loadable/component';
import styled from 'styled-components';
import { tc } from 'utils/theme';

import { AppContext } from 'contexts/AppContext';

const H2 = loadable(() => import('components/Atoms/H2'));
const Logo = loadable(() => import('components/Atoms/Logo'));
const Link = loadable(() => import('components/Atoms/Link'));
const Icon = loadable(() => import('components/Atoms/Icon'));
const LayoutAuth = loadable(() => import('components/Organisms/LayoutAuth'));
const Form = loadable(() => import('components/Organisms/FormForgotPassword'));

const Content = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const StyledLogo = styled(Logo)`
  width: 100%;
  height: 140px;
`;

const StyledText = styled.p`
  text-align: center;
  margin: 30px 0;
`;

const StyledIcon = styled(Icon)`
  && {
    font-size: 50px;
    color: ${tc('circleActiveColor')};
  }
`;

const ForgotPassword = () => {
  const { organizationId, propertyId } = useContext(AppContext);

  const [success, setSuccess] = useState(false);

  const onSubmitSuccess = () => {
    setSuccess(true);
  };

  const RenderForm = () => (
    <>
      <H2 center>Forgot your password?</H2>
      <StyledText>
        Enter your email address and we will send you a link to reset your
        password.
      </StyledText>
      <Form onSubmitSuccess={onSubmitSuccess} />
      <StyledText>
        <Link to={`/${organizationId}/${propertyId}`}>Return to Login</Link>
      </StyledText>
    </>
  );

  const RenderSuccess = () => (
    <>
      <H2 center>Reset Password Link Sent!</H2>
      <StyledText>
        <StyledIcon iconName="et-circle-check" />
      </StyledText>
      <StyledText>
        A link to reset your password has been sent to the email address you
        provided.
      </StyledText>
      <StyledText>
        <Button variant={'primary'} to={`/${organizationId}/${propertyId}`}>
          Return to Login
        </Button>
      </StyledText>
    </>
  );

  return (
    <LayoutAuth>
      <Content>
        <StyledLogo padBottom />
        {success === false && <RenderForm />}
        {success === true && <RenderSuccess />}
      </Content>
    </LayoutAuth>
  );
};

export default ForgotPassword;
